import { TestIdDomain } from 'constants/testIds';

export const PartiesTestIds = {
  PREVIEW_BUTTON: `${TestIdDomain.LOAN_PARTIES}.preview-button`,
  PREVIEW_SUMMARY: `${TestIdDomain.LOAN_PARTIES}.preview-summary`,
  PARTIES_TABLE: `${TestIdDomain.LOAN_PARTIES}.parties-table`,
  ADD_CONTACT_BUTTON: `${TestIdDomain.LOAN_PARTIES}.add-contact-button`,
  ROW_ACTION_BUTTON: `${TestIdDomain.LOAN_PARTIES}.row-action-button`,
  ROW_ACTION_MENU: `${TestIdDomain.LOAN_PARTIES}.row-action-menu`,
  PREVIEW_PANEL: `${TestIdDomain.LOAN_PARTIES}.preview-panel`,
  PREVIEW_MAPPING_DISABLED: `${TestIdDomain.LOAN_PARTIES}.preview-mapping-disabled`,
  PREVIEW_ISSUE: `${TestIdDomain.LOAN_PARTIES}.preview-issue`,
  PREVIEW_PARTICIPANTS_TABLE: `${TestIdDomain.LOAN_PARTIES}.preview-participants-table`,
};
